<template>
  <NewPasswordForm :error4017="error4017" @submit="submit" @cancel="cancel" />
</template>

<script>
import { changePassword } from "@/services/user";
import { toLogin } from "@/utils/redirects";
import { PASSWORD_REUSED_MESSAGE, INVALID_RESET_TOKEN_MESSAGE } from "@/utils/password";
import NewPasswordForm from "@/components/NewPasswordForm.vue";

export default {
  name: "PasswordStrengthForm",
  components: {
    NewPasswordForm,
  },
  data() {
    return {
      password: "",
      confirmPassword: "",
      showPass: false,
      showConfirmPass: false,
      error4017: false,
      loading: false,
    };
  },
  methods: {
    cancel() {
      toLogin();
    },
    submit(password) {
      this.loading = true;

      const payload = {
        new_password: password,
        token: this.$route.query.token,
      };

      changePassword(payload)
        .then(() => {
          this.$emit("snackbar", { message: "Senha alterada com sucesso" });
          this.error4017 = false;
          toLogin();
        })
        .catch((err) => {
          const errors = err.response?.data?.errors || [];
          const error4017 = errors.find((e) => e.code === 4017);
          const error4007 = errors.find((e) => e.code === 4007);
          this.error4017 = !!error4017;

          let message = "Não foi possível alterar a senha";
          if (error4017) {
            message = PASSWORD_REUSED_MESSAGE;
          } else if (error4007) {
            message = INVALID_RESET_TOKEN_MESSAGE;
          }

          this.$emit("snackbar", { message });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
